import { render, staticRenderFns } from "./UserTwoFactorForm.vue?vue&type=template&id=4ea636b2"
import script from "./UserTwoFactorForm.vue?vue&type=script&lang=js"
export * from "./UserTwoFactorForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports